// ==========================================================================
// Responsive CSS to JS
// ==========================================================================

import {isTouch} from 'groots/utilities';

document.addEventListener('DOMContentLoaded', function() {
    // Breakpoints to JS
    var breakpointsList = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
    breakpointsList = breakpointsList.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
    window.groots.breakpoints = JSON.parse(breakpointsList);

    // Set touch CSS helper
    if (isTouch()) document.body.classList.add('u-is-touch');
});
